import { jsx as _jsx } from "react/jsx-runtime";
import { Outlet } from 'react-router-dom';
var OtherLayout = function () {
    return _jsx(Outlet, {});
};
export default OtherLayout;
